
















import { Component, PropSync, Vue } from 'vue-property-decorator';

@Component
export default class Alert extends Vue {
  @PropSync('text', { type: String }) syncedText!: string;

  get show() {
    return !!this.syncedText;
  }
  set show(v: any) {
    if (!v) this.syncedText = '';
  }
}
